"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function VoucherCreate(row) {
  var targetEntity = (0, _get2["default"])(row, 'targetEntity');
  var quantity = (0, _get2["default"])(row, 'quantity');
  var isWooCommerce = !!(0, _get2["default"])(row, 'metadata.orderId');
  if (targetEntity && isWooCommerce) {
    if (quantity !== null) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Created voucher ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " with ", quantity, " license", quantity === 1 ? '' : 's', " via WooCommerce purchase");
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Created voucher ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " via WooCommerce purchase");
  }
  if (targetEntity) {
    if (quantity !== null) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Admin created voucher ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " with ", quantity, " license", quantity === 1 ? '' : 's');
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin created voucher ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  if (isWooCommerce) {
    if (quantity !== null) {
      return /*#__PURE__*/_react["default"].createElement("span", null, "Created voucher with ", quantity, " license", quantity === 1 ? '' : 's', " via WooCommerce purchase, but voucher has since been deleted");
    }
    return /*#__PURE__*/_react["default"].createElement("span", null, "Created voucher via WooCommerce purchase, but voucher has since been deleted");
  }
  if (quantity !== null) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Admin created voucher with ", quantity, " license", quantity === 1 ? '' : 's', ", but voucher has since been deleted");
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Admin created voucher, but voucher has since been deleted");
}
var _default = exports["default"] = VoucherCreate;